"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var syncNativeState_exports = {};
__export(syncNativeState_exports, {
  syncHandleOf: () => syncHandleOf,
  useNativeState: () => useNativeState,
  useSyncValue: () => useSyncValue
});
module.exports = __toCommonJS(syncNativeState_exports);
var import_react = require("react");
var import_syncStore = require("./syncStore");
function useNativeState(initial) {
  var ref = (0, import_react.useRef)(null);
  if (ref.current === null) {
    ref.current = (0, import_syncStore.createSyncState)(initial);
  }
  var state = ref.current;
  (0, import_react.useSyncExternalStore)(state.subscribe, state.getSnapshot, state.getSnapshot);
  return state;
}
function syncHandleOf(value) {
  return (0, import_syncStore.isSyncState)(value) ? value : null;
}
function useSyncValue(value) {
  var handle = syncHandleOf(value);
  var subscribe = (0, import_react.useCallback)(function(notify) {
    return handle ? handle.subscribe(notify) : function() {
    };
  }, [
    handle
  ]);
  var getSnapshot = (0, import_react.useCallback)(function() {
    return handle ? handle.getSnapshot() : value;
  }, [
    handle,
    value
  ]);
  return (0, import_react.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
}
//# sourceMappingURL=syncNativeState.js.map
